import styled from 'styled-components';

import { colorTokens, fontTokens } from '../../../tokens/globals/tokens';

import { notesHeight } from '../constants';

const SpreadsheetTableNotes = styled.div<{ position?: string }>`
  background-color: ${colorTokens.GlobalBrandWhite};
  border-bottom: ${({ position }) => (position === 'top' ? `1px solid ${colorTokens.GlobalBrandGray40}` : `0`)};
  border-top: ${({ position }) => (position === 'top' ? `0` : `1px solid ${colorTokens.GlobalBrandGray40}`)};
  border-left: 1px solid ${colorTokens.GlobalBrandGray40};
  font-weight: ${fontTokens.GlobalWeightBody2};
  height: ${notesHeight}px;
  max-height: ${notesHeight}px;
  min-height: ${notesHeight}px;
  padding: 4px 20px 6px;
  width: 100%;
`;

export { SpreadsheetTableNotes };
